import React, { useEffect, useRef } from "react";
import Parallax from "parallax-js";

import { Link } from "react-router-dom";
import Typed from 'typed.js';
import WinGridLight from "./WinGridLight";

const MobileVideo = () => {
  return (
    <div className="block lg:hidden order-2 -mx-4 sm:-mx-8 mb-8">
      <div className="relative z-10 w-screen pointer-events-none -ml-4">
        <div className="w-full pointer-events-none overflow-hidden">
          <video
            width="1800"
            height="auto"
            autoPlay
            loop
            muted
            playsInline
            style={{
              background: 'transparent',
              maxWidth: '100%',
              transform: 'scale(1)'
            }}
            className="w-full h-full object-contain mix-blend-screen -ml-0"
          >
            <source src="https://firebasestorage.googleapis.com/v0/b/aiar-25d06.appspot.com/o/hero_video_final.mp4?alt=media&token=a2f23b67-8017-4119-ac22-3f37c209154d" />
          </video>
        </div>
      </div>
    </div>
  );
};

const DesktopVideo = () => {
  return (
    <div className="relative h-full w-full flex items-center justify-center pointer-events-none lg:flex">
      {/* Main container */}
      <div className="relative w-full flex items-center justify-center">
        {/* Blue shadow background - positioned behind video */}
        <div className="absolute w-full flex items-center justify-center">
          <img
            className="w-full h-auto object-contain mx-auto xl:scale-90 hidden xl:block"
            style={{
              width: '150%',
              height: 'auto',
              maxWidth: '1100px',
            }}
            src={require("../../assets/images/home-one-hero-circle-shadow.svg").default}
            alt="Circle shadow background"
          />
        </div>
        
        {/* Video container with white border */}
        <div className="relative z-10 overflow-hidden xl:max-w-[700px] lg:max-w-[450px] sm:max-w-[500px] max-w-[500px] lg:mb-0 md:mb-52 sm:mb-52 mb-40" 
             style={{ 
               borderRadius: '10px',
               boxShadow: '0 0 0 12px white',
               width: '100%',
             }}>
          <video
            width="100%"
            height="auto"
            autoPlay
            loop
            muted
            playsInline
            style={{
              borderRadius: '10px',
              display: 'block'
            }}
          >
            <source src="https://firebasestorage.googleapis.com/v0/b/aiar-25d06.appspot.com/o/informulate.ai%2Fbusiness%20intro.mp4?alt=media&token=2bdfd465-f2dd-4ee3-aee4-c49dc88601e8" />
          </video>
        </div>
      </div>
    </div>
  );
};

const HeroContent = ({ typedRef, mobileTypedRef }) => {
  return (
    <div className="article-area flex flex-col xl:py-20 lg:py-8 py-10 lg:pr-4 xl:max-w-none lg:max-w-[500px]">
      <div className="w-fit inline-flex md:px-6 px-3 py-2.5 md:pb-[14px] bg-white space-x-2.5 items-center rounded-full shadow-style-one mb-5">
        <span className="text-sm font-regular pointer-events-none md:text-20 text-purple">
          Your <span className="font-semibold">AI-first</span> Consulting Partner
        </span>
      </div>
      <h2 className="hidden lg:block text-main-black font-semibold mb-[35px] pointer-events-none relative xl:text-65 lg:text-4xl">
        <span>Create Massive</span> <br />
        <span>Business Value</span> <br />
        <span>With </span>
        <span className="relative inline-block">
          <span className="relative z-10 text-black">
            <span ref={typedRef}></span>
          </span>
          <span className="absolute top-0 left-0 block w-full h-full bg-yellow px-3"></span>
        </span>
      </h2>
      <h2 className="block lg:hidden text-3xl sm:text-4xl md:text-5xl text-main-black font-semibold mb-[35px] pointer-events-none relative px-4">
        <span>Launch Your</span> <br />
        <span>AI Superpowers with</span> <br />
        <span className="relative inline-flex w-auto">
          <span className="relative z-10 text-black whitespace-nowrap">
            <span ref={mobileTypedRef}></span>
          </span>
          <span
            className="absolute top-0 left-0 h-full bg-yellow"
            style={{
              width: '100%',
              padding: '0 0.75rem'
            }}>
          </span>
        </span>
      </h2>
      <div className="px-4 sm:px-6 py-[14px] bg-white border-l-2 border-blue-sass mb-[35px] pointer-events-none xl:w-full lg:w-[400px] md:w-[450px] w-full order-3">
        <p className="text-ptwo text-paragraph lg:text-sm xl:text-base">
          We combine state-of-the-art Gen AI expertise with decades of wisdom in product development, to deliver innovative solutions. We partner with you on tech strategy, quality execution, and business adoption to create impact at scale.
        </p>
      </div>
      <div className="flex space-x-[30px] items-center pointer-events-none order-4">
        <a href="#contact" className="pointer-events-auto">
          <div className="py-3 home-two-btn-bg group bg-purple border-blue-seo pointer-events-auto">
            <span className="relative z-10 text-base font-semibold text-white transition-all duration-300 group-hover:text-purple font-inter">
              Get Started
            </span>
            <svg
              className="relative z-10"
              width="7"
              height="12"
              viewBox="0 0 7 12"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                className="transition-all duration-300 group-hover:stroke-blue-seo"
                d="M1.10254 10.5L4.89543 6.70711C5.22877 6.37377 5.39543 6.20711 5.39543 6C5.39543 5.79289 5.22877 5.62623 4.89543 5.29289L1.10254 1.5"
                stroke="white"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              ></path>
            </svg>
          </div>
        </a>
      </div>

      {/* Mobile Video Component */}
      {/* <MobileVideo /> */}
    </div>
  );
};

export default function HeroSection() {
  const sceneRef = useRef(null);
  const typedRef = useRef(null);
  const mobileTypedRef = useRef(null);

  useEffect(() => {
    if (sceneRef.current) {
      const parallaxInstance = new Parallax(sceneRef.current, {
        relativeInput: true,
        hoverOnly: true,
        pointerEvents: true
      });

      // Cleanup the parallax instance on component unmount
      return () => {
        parallaxInstance.disable();
      };
    }
  }, []);

  useEffect(() => {
    const options = {
      strings: [
        'Innovation^2000',
        'Ingenuity^2000',
        'Informulate^5000'
      ],
      typeSpeed: 90,
      backSpeed: 70,
      loop: false,
      showCursor: true,
      cursorChar: '|',
      cursorClassName: 'typed-cursor-black',
    };

    const typed = new Typed(typedRef.current, options);
    const mobileTyped = new Typed(mobileTypedRef.current, options);

    return () => {
      typed.destroy();
      mobileTyped.destroy();
    };
  }, []);

  return (
    <section
      id="banner"
      className="relative w-full bg-main-gray min-h-[calc(100vh)] pt-[75px] lg:pt-[calc(75px+var(--celebration-banner-height))] overflow-hidden"
    >
      <div className="hero-one-section-wrapper w-full h-full relative">
        <div className="absolute inset-0 w-full h-full">
          <WinGridLight />
        </div>
        <div className="relative z-10 h-full mx-auto theme-container pointer-events-none">
          <div className="w-full min-h-[calc(100vh-75px)] lg:min-h-[calc(100vh-75px-var(--celebration-banner-height))] grid xl:grid-cols-2 lg:grid-cols-2 grid-cols-1 xl:gap-[100px] 2xl:gap-[150px] lg:gap-2 gap-10 items-center justify-items-center">
            <div className="h-full flex items-center lg:justify-end justify-center w-full">
              <HeroContent typedRef={typedRef} mobileTypedRef={mobileTypedRef} />
            </div>
            <div className="h-full flex items-center lg:justify-start justify-center w-full">
              <DesktopVideo />
            </div>
          </div>
          
          {/* Down arrow button - only visible on md screens and up */}
          <div className="absolute bottom-16 left-1/2 transform -translate-x-1/2 z-20 pointer-events-auto hidden md:flex">
            <a 
              href="#about" 
              className="flex flex-col items-center justify-center transition-all duration-300 hover:translate-y-1"
              style={{ cursor: 'pointer' }}
            >
              <div className="w-10 h-10 rounded-full border-2 border-purple flex items-center justify-center transition-all duration-300 hover:bg-purple group">
                <svg 
                  xmlns="http://www.w3.org/2000/svg" 
                  className="h-5 w-5 text-purple transition-all duration-300 group-hover:text-white" 
                  fill="none" 
                  viewBox="0 0 24 24" 
                  stroke="currentColor"
                >
                  <path 
                    strokeLinecap="round" 
                    strokeLinejoin="round" 
                    strokeWidth={2}
                    className="transition-all duration-300 group-hover:stroke-[3]"
                    d="M19 14l-7 7m0 0l-7-7m7 7V3" 
                  />
                </svg>
              </div>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
